export interface PlanningCourse {
  id: number;
  name: string;
}

export const DASHBOARD_COURSE_STORAGE_SUFFIX = 'dashboard.courseId';

export function pickPreferredCourseId(
  courses: PlanningCourse[],
  hints: {
    storedId?: number | null;
    sessionCourseId?: number | null;
    lastActiveCourseId?: number | null;
  } = {},
): number | null {
  const usable = courses.filter((course) => Number.isFinite(course.id) && course.id > 0);
  if (usable.length === 0) {
    return null;
  }
  const ids = new Set(usable.map((course) => course.id));
  for (const candidate of [hints.storedId, hints.lastActiveCourseId, hints.sessionCourseId]) {
    const id = Number(candidate);
    if (Number.isFinite(id) && ids.has(id)) {
      return id;
    }
  }
  return [...usable].sort(compareTrainingCourses)[0].id;
}

export function compareTrainingCourses(a: PlanningCourse, b: PlanningCourse): number {
  const rankDelta = airplaneRank(a.name) - airplaneRank(b.name);
  if (rankDelta !== 0) {
    return rankDelta;
  }
  const byName = a.name.localeCompare(b.name);
  return byName !== 0 ? byName : a.id - b.id;
}

export function parseStoredCourseId(raw: string | null | undefined): number | null {
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
}

function airplaneRank(name: string): number {
  const n = (name || '').toLowerCase();
  if (/\batpl[\s-]*h\b|\batpl\s*\(\s*h\s*\)|helicopter/.test(n)) {
    return 2;
  }
  if (/\batpl[\s-]*a\b|\batpl\s*\(\s*a\s*\)/.test(n)) {
    return 0;
  }
  return 1;
}
